import type { StateCreator } from "zustand";
import {
  type SegmentStateSlice,
  createSegmentInitialState,
  deleteSegmentInitialState,
  segmentsInitialState,
  updateSegmentInitialState,
} from "./segment.slice";

type SegmentActions = Pick<
  SegmentStateSlice,
  | "setSegmentColor"
  | "setFeedId"
  | "setSegmentName"
  | "setKeyMessageId"
  | "setSavedViewId"
  | "setIsCreateOrEditSegmentModalOpen"
  | "setIsDeleteSegmentModalOpen"
  | "setDeleteSegmentId"
  | "onEditSegment"
  | "resetSegment"
  | "resetDeleteSegment"
  | "resetFetchedSegments"
>;

export const createSegmentActions: StateCreator<
  SegmentStateSlice,
  [["zustand/devtools", never]],
  [],
  SegmentActions
> = (set) => ({
  setFeedId: (id: string) =>
    set(
      { feedId: id, keyMessageId: null, name: "" },
      false,
      "[User] Segment: Set brand",
    ),
  setSegmentName: (name: string) =>
    set({ name }, false, "[User] Segment: Set segment name"),
  setKeyMessageId: (id: string | null) =>
    set({ keyMessageId: id }, false, "[User] Segment: Set key message id"),
  setSavedViewId: (id: string | null) =>
    set({ savedViewId: id }, false, "[User] Segment: Set saved view id"),
  setSegmentColor: (color: string) =>
    set({ color }, false, "[User] Segment: Set segment color"),
  setIsCreateOrEditSegmentModalOpen: (isOpen: boolean) =>
    set(
      { isCreateOrEditSegmentModalOpen: isOpen },
      false,
      "[User] Segment: Toggle create or edit segment modal open",
    ),
  setIsDeleteSegmentModalOpen: (isOpen: boolean) =>
    set(
      { isDeleteSegmentModalOpen: isOpen },
      false,
      "[User] Segment: Toggle delete segment modal open",
    ),
  setDeleteSegmentId: (id: string | null) =>
    set(
      { deleteSegmentId: id },
      false,
      "[User] Segment: Set delete segment id",
    ),

  onEditSegment: ({ segmentId, color, name }) =>
    set(
      {
        updateSegmentId: segmentId,
        color,
        name,
      },
      false,
      "[User] Segment: Set edit segment data",
    ),

  resetSegment: () =>
    set(
      { ...createSegmentInitialState, ...updateSegmentInitialState },
      false,
      "Reset segment state",
    ),
  resetDeleteSegment: () =>
    set(
      {
        ...deleteSegmentInitialState,
        name: "",
      },
      false,
      "Reset delete segment state",
    ),
  resetFetchedSegments: () =>
    set({ ...segmentsInitialState }, false, "Reset Fetch Segments"),
});
